﻿const oidc = require('../plugin/oidc-client-ts');

var Config = {
    webApiUrl: function () {
        var location = '';
        switch (window.location.host) {
            case 'localhost:7072': location = window.location.protocol + '//' + 'localhost:7072'; break;
            case 'events4usproduction.azurewebsites.net': location = window.location.protocol + '//' + 'events4usproduction.azurewebsites.net'; break;
            case 'events4us.net': location = window.location.protocol + '//' + 'events4us.net'; break;
            case 'www.events4us.net': location = window.location.protocol + '//' + 'www.events4us.net'; break;
            case 'events4us.dk': location = window.location.protocol + '//' + 'events4us.dk'; break;
            case 'www.events4us.dk': location = window.location.protocol + '//' + 'www.events4us.dk'; break;
            case 'events4usproduction-test.azurewebsites.net': location = window.location.protocol + '//' + 'events4usproduction-test.azurewebsites.net'; break;
            case 'test.events4us.net': location = window.location.protocol + '//' + 'test.events4us.net'; break;
        }

        return location;
    },
    signalRUrl: function () {
        var location = '';
        switch (window.location.host) {
            case 'localhost:7072': location = window.location.protocol + '//' + 'localhost:7072'; break;
            case 'events4usproduction.azurewebsites.net': location = window.location.protocol + '//' + 'events4ussignalrproduction.azurewebsites.net'; break;
            //case 'events4us.net': location = window.location.protocol + '//' + 'signalr.events4us.net'; break;
            //case 'www.events4us.net': location = window.location.protocol + '//' + 'signalr.events4us.net'; break;
            //case 'events4us.dk': location = window.location.protocol + '//' + 'signalr.events4us.dk'; break;
            //case 'www.events4us.dk': location = window.location.protocol + '//' + 'signalr.events4us.dk'; break;
            case 'events4us.net': location = window.location.protocol + '//' + 'events4us.net'; break;
            case 'www.events4us.net': location = window.location.protocol + '//' + 'events4us.net'; break;
            case 'events4us.dk': location = window.location.protocol + '//' + 'events4us.net'; break;
            case 'www.events4us.dk': location = window.location.protocol + '//' + 'events4us.net'; break;
            case 'events4usproduction-test.azurewebsites.net': location = window.location.protocol + '//' + 'events4ussignalrproduction-test.azurewebsites.net'; break;
            case 'test.events4us.net': location = window.location.protocol + '//' + 'test.signalr.events4us.net'; break;
        }

        return location;
    },
    paymentGateway_EPay_merchantnumberValue: function () {
        //var merchantnumberValue = '8026550';
        //switch (window.location.host) {
        //    case 'localhost:7072': merchantnumberValue = '8026550'; break;
        //    case 'events4usproduction.azurewebsites.net': merchantnumberValue = '8026550'; break;
        //    case 'events4us.net': merchantnumberValue = '8026550'; break;
        //    case 'events4usproduction-test.azurewebsites.net': merchantnumberValue = '8026550'; break;
        //    case 'test.events4us.net': merchantnumberValue = '8026550'; break;
        //}
        //
        //return merchantnumberValue;

        return window.app.entities.models.publicSetting.attributes.EPay_Merchantnumber;
    },
    paymentGateway_EPay_windowidValue: function () {
        var windowidValue = '3';
        switch (window.location.host) {
            case 'localhost:7072': windowidValue = '3'; break;
            case 'events4usproduction.azurewebsites.net': windowidValue = '3'; break;
            case 'events4us.net': windowidValue = '3'; break;
            case 'www.events4us.net': windowidValue = '3'; break;
            case 'events4us.dk': windowidValue = '3'; break;
            case 'www.events4us.dk': windowidValue = '3'; break;
            case 'events4usproduction-test.azurewebsites.net': windowidValue = '3'; break;
            case 'test.events4us.net': windowidValue = '3'; break;
        }

        return windowidValue;
    },
    cultureName: function () {
        return window.event4us.config.cultureName;
    },
    authUserId: function () {
        return window.event4us.config.authUserId;
    },
    online: function () {
        //return window.event4us.config.online;

        switch (window.location.host) {
            case 'localhost:7072': return false; break;
            case 'events4usproduction.azurewebsites.net': return false; break;
            case 'events4us.net': return false; break;
            case 'www.events4us.net': return false; break;
            case 'events4us.dk': return false; break;
            case 'www.events4us.dk': return false; break;
            case 'events4usproduction-test.azurewebsites.net': return false; break;
            case 'test.events4us.net': return false; break;
        }

        return false;
    },
    cdn: function () {
        var location = '';
        switch (window.location.host) {
            //case 'localhost:7072': location = window.location.protocol + '//' + 'events4ustest.azureedge.net'; break;
            case 'localhost:7072': location = window.location.protocol + '//' + 'e4ustest.blob.core.windows.net'; break;
            case 'events4usproduction.azurewebsites.net': location = window.location.protocol + '//' + 'cdn.events4us.net'; break;
            //case 'events4us.net': location = window.location.protocol + '//' + 'cdn.events4us.net'; break;
            //case 'www.events4us.net': location = window.location.protocol + '//' + 'cdn.events4us.net'; break;
            //case 'events4us.dk': location = window.location.protocol + '//' + 'cdn.events4us.dk'; break;
            //case 'www.events4us.dk': location = window.location.protocol + '//' + 'cdn.events4us.dk'; break;
            case 'events4us.net': location = window.location.protocol + '//' + 'e4usproduction.blob.core.windows.net'; break;
            case 'www.events4us.net': location = window.location.protocol + '//' + 'e4usproduction.blob.core.windows.net'; break;
            case 'events4us.dk': location = window.location.protocol + '//' + 'e4usproduction.blob.core.windows.net'; break;
            case 'www.events4us.dk': location = window.location.protocol + '//' + 'e4usproduction.blob.core.windows.net'; break;
            case 'events4usproduction-test.azurewebsites.net': location = window.location.protocol + '//' + 'e4ustest.blob.core.windows.net'; break;
                //case 'test.events4us.net': location = window.location.protocol + '//' + 'events4ustest.azureedge.net'; break;
            case 'test.events4us.net': location = window.location.protocol + '//' + 'e4ustest.blob.core.windows.net'; break;
            
        }

        //switch (window.location.host) {
        //    case 'localhost:7072': location = window.location.protocol + '//' + 'endpoint930814.azureedge.net'; break;
        //    case 'events4usproduction.azurewebsites.net': location = window.location.protocol + '//' + 'cdn.events4us.net'; break;
        //    case 'events4us.net': location = window.location.protocol + '//' + 'cdn.events4us.net'; break;
        //    case 'events4usproduction-test.azurewebsites.net': location = window.location.protocol + '//' + 'endpoint930814.azureedge.net'; break;
        //    case 'test.events4us.net': location = window.location.protocol + '//' + 'endpoint930814.azureedge.net'; break;
        //}

        return location;
    },
    languageJson: function () {
        return window.event4us.config.languageJson;
    },
    languageSettingJson: function () {
        return window.event4us.config.languageSettingJson;
    },
    languageValidationJson: function () {
        return window.event4us.config.languageValidationJson;
    },
    fontJson: function () {
        return window.event4us.config.fontJson;
    },
    moduleJson: function () {
        return window.event4us.config.moduleJson;
    },
    defaultTemplateJson: function () {
        return window.event4us.config.defaultTemplateJson;
    },
    editorJson: function () {
        return window.event4us.config.editorJson;
    },
    templateJson: function () {
        return window.event4us.config.templateJson;
    },
    portalHelpJson: function () {
        return window.event4us.config.portal_helpJson;
    },
    fileJson: function () {
        return window.event4us.config.fileJson;
    },
    googleMapsLoaderKEY() {
        //return 'AIzaSyB_OBFUvh8nL1aWS8iNQII5Mrl_kcLWnXU'; //steenevents4us@gmail.com
        return 'AIzaSyBSrmFddGdjeQUvL3m0gLEn36gYD3s3Xe0'; //mash.development.net@gmail.com
    },
    googleMapsLoaderLIBRARIES() {
        return ['geometry', 'places'];
    },
    googleRecaptchaSiteKey() {
        //return '6LdvhSkTAAAAAKdtDyjpCgmlfGvSCurYDg1WdpO9'; //steenevents4us@gmail.com
        return '6LfvIgsUAAAAAIFAwrIsdK0w_y4Y126KqB8b7c6w'; //mash.development.net@gmail.com
    },
    googleAdSenseAdslot() {
        //return '1462621237'; //steenevents4us@gmail.com
        //return '1462621237'; //mash.development.net@gmail.com
        return '0000000000';
    },
    facebookAppId() {
        switch (window.location.host) {
            case 'localhost:7072': return '226121817833273'; break; //sh.shoopster@yahoo.dk
            case 'events4usproduction.azurewebsites.net': return '262115594208005'; break;
            case 'events4us.net': return '1826662877573904'; break;
            case 'www.events4us.net': return '1826662877573904'; break;
            case 'events4us.dk': return '1826662877573904'; break;
            case 'www.events4us.dk': return '1826662877573904'; break;
            case 'events4usproduction-test.azurewebsites.net': return '998134476928041'; break;
            case 'test.events4us.net': return '1368508166561090'; break;
        }
    },
    getAuthConfig: function () {
        var authority = '';
        switch (window.location.host) {
            case 'localhost:7072': authority = window.location.protocol + '//' + 'localhost:44314'; break;
            case 'events4usproduction.azurewebsites.net': authority = window.location.protocol + '//' + 'events4usauthproduction.azurewebsites.net'; break;
            case 'events4us.net': authority = window.location.protocol + '//' + 'auth.events4us.net'; break;
            case 'www.events4us.net': authority = window.location.protocol + '//' + 'auth.events4us.net'; break;
            case 'events4us.dk': authority = window.location.protocol + '//' + 'auth.events4us.net'; break;
            case 'www.events4us.dk': authority = window.location.protocol + '//' + 'auth.events4us.net'; break;
            case 'events4usproduction-test.azurewebsites.net': authority = window.location.protocol + '//' + 'events4usauthproduction-test.azurewebsites.net'; break;
            case 'test.events4us.net': authority = window.location.protocol + '//' + 'test.auth.events4us.net'; break;
        }

        var redirect_uri = '';
        switch (window.location.host) {
            case 'localhost:7072': redirect_uri = window.location.protocol + '//' + 'localhost:7072/signin-callback.html'; break;
            case 'events4usproduction.azurewebsites.net': redirect_uri = window.location.protocol + '//' + 'events4usauthproduction.azurewebsites.net/signin-callback.html'; break;
            case 'events4us.net': redirect_uri = window.location.protocol + '//' + 'events4us.net/signin-callback.html'; break;
            case 'www.events4us.net': redirect_uri = window.location.protocol + '//' + 'events4us.net/signin-callback.html'; break;
            case 'events4us.dk': redirect_uri = window.location.protocol + '//' + 'events4us.dk/signin-callback.html'; break;
            case 'www.events4us.dk': redirect_uri = window.location.protocol + '//' + 'events4us.dk/signin-callback.html'; break;
            case 'events4usproduction-test.azurewebsites.net': redirect_uri = window.location.protocol + '//' + 'events4usauthproduction-test.azurewebsites.net/signin-callback.html'; break;
            case 'test.events4us.net': redirect_uri = window.location.protocol + '//' + 'test.auth.events4us.net/signin-callback.html'; break;
        }

        var post_logout_redirect_uri = '';
        switch (window.location.host) {
            case 'localhost:7072': post_logout_redirect_uri = window.location.protocol + '//' + 'localhost:7072/index.html'; break;
            case 'events4usproduction.azurewebsites.net': post_logout_redirect_uri = window.location.protocol + '//' + 'events4usauthproduction.azurewebsites.net/index.html'; break;
            case 'events4us.net': post_logout_redirect_uri = window.location.protocol + '//' + 'events4us.net/index.html'; break;
            case 'www.events4us.net': post_logout_redirect_uri = window.location.protocol + '//' + 'events4us.net/index.html'; break;
            case 'events4us.dk': post_logout_redirect_uri = window.location.protocol + '//' + 'events4us.dk/index.html'; break;
            case 'www.events4us.dk': post_logout_redirect_uri = window.location.protocol + '//' + 'events4us.dk/index.html'; break;
            case 'events4usproduction-test.azurewebsites.net': post_logout_redirect_uri = window.location.protocol + '//' + 'events4usauthproduction-test.azurewebsites.net/index.html'; break;
            case 'test.events4us.net': post_logout_redirect_uri = window.location.protocol + '//' + 'test.auth.events4us.net/index.html'; break;
        }

        const authConfig = {
            authority: authority,
            scope: 'openid api1',
            client_id: 'spa',
            redirect_uri: redirect_uri,
            response_type: 'code',
            userStore: new oidc.WebStorageStateStore({ store: window.localStorage })
        };

        return authConfig;
    }
    //getAuthConfig: function () {
    //    var authority = '';
    //    switch (window.location.host) {
    //        case 'localhost:7072': authority = window.location.protocol + '//' + 'localhost:5002'; break;
    //        case 'events4usproduction.azurewebsites.net': authority = window.location.protocol + '//' + 'events4usauthproduction.azurewebsites.net'; break;
    //        case 'events4us.net': authority = window.location.protocol + '//' + 'auth.events4us.net'; break;
    //        case 'www.events4us.net': authority = window.location.protocol + '//' + 'auth.events4us.net'; break;
    //        case 'events4us.dk': authority = window.location.protocol + '//' + 'auth.events4us.dk'; break;
    //        case 'www.events4us.dk': authority = window.location.protocol + '//' + 'auth.events4us.dk'; break;
    //        case 'events4usproduction-test.azurewebsites.net': authority = window.location.protocol + '//' + 'events4usauthproduction-test.azurewebsites.net'; break;
    //        case 'test.events4us.net': authority = window.location.protocol + '//' + 'test.auth.events4us.net'; break;
    //    }

    //    var redirect_uri = '';
    //    switch (window.location.host) {
    //        case 'localhost:7072': redirect_uri = window.location.protocol + '//' + 'localhost:7072/callback.html'; break;
    //        case 'events4usproduction.azurewebsites.net': redirect_uri = window.location.protocol + '//' + 'events4usproduction.azurewebsites.net/callback.html'; break;
    //        case 'events4us.net': redirect_uri = window.location.protocol + '//' + 'events4us.net/callback.html'; break;
    //        case 'www.events4us.net': redirect_uri = window.location.protocol + '//' + 'www.events4us.net/callback.html'; break;
    //        case 'events4us.dk': redirect_uri = window.location.protocol + '//' + 'events4us.dk/callback.html'; break;
    //        case 'www.events4us.dk': redirect_uri = window.location.protocol + '//' + 'www.events4us.dk/callback.html'; break;
    //        case 'events4usproduction-test.azurewebsites.net': redirect_uri = window.location.protocol + '//' + 'events4usproduction-test.azurewebsites.net/callback.html'; break;
    //        case 'test.events4us.net': redirect_uri = window.location.protocol + '//' + 'test.events4us.net/callback.html'; break;
    //    }

    //    var post_logout_redirect_uri = '';
    //    switch (window.location.host) {
    //        case 'localhost:7072': post_logout_redirect_uri = window.location.protocol + '//' + 'localhost:7072/index.html#index'; break;
    //        case 'events4usproduction.azurewebsites.net': post_logout_redirect_uri = window.location.protocol + '//' + 'events4usproduction.azurewebsites.net/index.html#index'; break;
    //        case 'events4us.net': post_logout_redirect_uri = window.location.protocol + '//' + 'events4us.net/index.html#index'; break;
    //        case 'www.events4us.net': post_logout_redirect_uri = window.location.protocol + '//' + 'www.events4us.net/index.html#index'; break;
    //        case 'events4us.dk': post_logout_redirect_uri = window.location.protocol + '//' + 'events4us.dk/index.html#index'; break;
    //        case 'www.events4us.dk': post_logout_redirect_uri = window.location.protocol + '//' + 'www.events4us.dk/index.html#index'; break;
    //        case 'events4usproduction-test.azurewebsites.net': post_logout_redirect_uri = window.location.protocol + '//' + 'events4usproduction-test.azurewebsites.net/index.html#index'; break;
    //        case 'test.events4us.net': post_logout_redirect_uri = window.location.protocol + '//' + 'test.events4us.net/index.html#index'; break;
    //    }

    //    var silent_renew_uri = ''
    //    switch (window.location.host) {
    //        case 'localhost:7072': silent_renew_uri = window.location.protocol + '//' + 'localhost:7072/silentrenew.html'; break;
    //        case 'events4usproduction.azurewebsites.net': silent_renew_uri = window.location.protocol + '//' + 'events4usproduction.azurewebsites.net/silentrenew.html'; break;
    //        case 'events4us.net': silent_renew_uri = window.location.protocol + '//' + 'events4us.net/silentrenew.html'; break;
    //        case 'www.events4us.net': silent_renew_uri = window.location.protocol + '//' + 'www.events4us.net/silentrenew.html'; break;
    //        case 'events4us.dk': silent_renew_uri = window.location.protocol + '//' + 'events4us.dk/silentrenew.html'; break;
    //        case 'www.events4us.dk': silent_renew_uri = window.location.protocol + '//' + 'www.events4us.dk/silentrenew.html'; break;
    //        case 'events4usproduction-test.azurewebsites.net': silent_renew_uri = window.location.protocol + '//' + 'events4usproduction-test.azurewebsites.net/silentrenew.html'; break;
    //        case 'test.events4us.net': silent_renew_uri = window.location.protocol + '//' + 'test.events4us.net/silentrenew.html'; break;
    //    }

    //    var allowedCorsOrigins_url = ''
    //    switch (window.location.host) {
    //        case 'localhost:7072': silent_renew_uri = "http://events4ustest.azureedge.net"; break;
    //        case 'events4usproduction.azurewebsites.net': silent_renew_uri = window.location.protocol + '//' + 'events4usproduction.azurewebsites.net/silentrenew.html'; break;
    //        case 'events4us.net': silent_renew_uri = window.location.protocol + '//' + 'events4us.net/silentrenew.html'; break;
    //        case 'www.events4us.net': silent_renew_uri = window.location.protocol + '//' + 'www.events4us.net/silentrenew.html'; break;
    //        case 'events4us.dk': silent_renew_uri = window.location.protocol + '//' + 'events4us.dk/silentrenew.html'; break;
    //        case 'www.events4us.dk': silent_renew_uri = window.location.protocol + '//' + 'www.events4us.dk/silentrenew.html'; break;
    //        case 'events4usproduction-test.azurewebsites.net': silent_renew_uri = window.location.protocol + '//' + 'events4usproduction-test.azurewebsites.net/silentrenew.html'; break;
    //        case 'test.events4us.net': silent_renew_uri = window.location.protocol + '//' + 'test.events4us.net/silentrenew.html'; break;
    //    }

    //    var authConfig = {
    //        //authority : 'http://localhost:5000',
    //        authority : authority,
    //        client_id : 'e4usclient',
    //        //redirect_uri : 'http://localhost:7072/callback.html',
    //        redirect_uri : redirect_uri,
    //        response_type : 'id_token token',
    //        scope : 'openid profile email Events4us',
    //        //post_logout_redirect_uri: 'http://localhost:7072/index.html#index'
    //        post_logout_redirect_uri : post_logout_redirect_uri,
    //        allowedCorsOrigins : allowedCorsOrigins_url,
    //        // Add expiration nofitication time
    //        //accessTokenExpiringNotificationTime: 4,
    //        //// Setup to renew token access automatically
    //        //automaticSilentRenew: true,
    //        //silent_redirect_uri: silent_renew_uri
    //        ui_locales : this.cultureName()
    //    };
    //    return authConfig;
    //}
};

export default Config;

